"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Study = exports.Project = exports.Proposal = void 0;
class Proposal {
    constructor(obj) {
        this.id = obj.id || -1;
        this.code_name = obj.code_name || '';
        this.name = obj.name || '';
        this.created_at = obj.created_at || new Date();
        this.updated_at = obj.updated_at || new Date();
        this.contact_info = obj.contact_info || '';
        this.crop = obj.crop || '';
    }
}
exports.Proposal = Proposal;
class Project {
    constructor(obj) {
        this.project_name = obj.project_name || '';
        this.samples_count = obj.samples_count || -1;
        this.locations = obj.locations || [];
        this.times = obj.times || [];
        this.treatments = obj.treatments || [];
    }
}
exports.Project = Project;
class Study {
    constructor(obj) {
        this.name = obj.name || '';
        this.version = obj.version || '--';
    }
}
exports.Study = Study;
